<template>
  <div @click="$emit('click')">
    <span v-if="level1" class="level_1" v-waves>+</span>
    <cl-svg-icon
      v-if="level2"
      width="22"
      :currentColor="false"
      icon-class="button_level2"
    ></cl-svg-icon>
  </div>
</template>

<script>
/**
 * ComponentName: button
 * Created Date:2022/4/24
 * Author: Nancy
 * 组件说明：
 * 这个组件是区分一级、二级页面内 添加button 样式，传type区分,默认是一级页面的添加按钮。
 * eg:
 *     <cl-button type="level-1"></cl-button> 一级页面
 *     <cl-button type="level-2"></cl-button> 二级页面
 */
export default {
  name: "cl-button",
  data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: "level-1",
    },
  },

  created() {},

  components: {},

  computed: {
    level1() {
      return this.type === "level-1";
    },
    level2() {
      return this.type === "level-2";
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.level_1 {
  display: inline-block;
  width: 34px;
  height: 34px;
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 20px;
  background-color: $base-color-theme;
  border-radius: 2px;
  cursor: pointer;
  //   box-shadow: 0px 6px 8px rgba(54, 99, 225, 0.3);

  &:hover {
    background-color: rgba(54, 99, 225, 0.9);
  }
}
</style>